export default {
    data() {
        return {

        }
    },

    methods: {

        scrollTo(targetTop, duration = 500) {
            const startTime = performance.now();
            const startScroll = window.scrollY || document.documentElement.scrollTop;

            const scroll = (timestamp) => {
                const elapsed = timestamp - startTime;
                const progress = Math.min(elapsed / duration, 1); // Ensure progress is between 0 and 1
                const easedProgress = this.easeInOutCubic(progress);
                const scrollTop = startScroll + (targetTop - startScroll) * easedProgress;
                window.scrollTo(0, scrollTop);

                if (elapsed < duration) {
                    requestAnimationFrame(scroll);
                }
            };

            requestAnimationFrame(scroll);
        },

        easeInOutCubic(t) {
            return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
        }
    },
}
